import { Link } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Breadcrumb from "@/components/layout/Breadcrumb";
import { faqList } from "@/mocks/faq";
import { brand } from "@/mocks/site";
import { useSeo } from "@/hooks/useSeo";

export default function Faq() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqList.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "全网热瓜常见问题",
      url: "https://w01xfj.cn/faq",
    },
  ];

  useSeo({
    title: "全网热瓜常见问题｜可信度·投稿·转载与吃瓜原则",
    description:
      "关于全网热瓜·热瓜雷达的常见问题：内容可信度如何保证、是否点名真实艺人、更新频率、如何投稿、转载授权方式，以及我们坚持拒绝网暴、冷静吃瓜的原则。",
    canonical: "https://w01xfj.cn/faq",
    jsonLd,
  });

  return (
    <>
      <Navbar />
      <main>
        <div className="mx-auto max-w-container px-4 pt-10 md:px-6">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />
        </div>

        <section className="mx-auto max-w-container px-4 pt-6 md:px-6">
          <div className="max-w-2xl">
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-600">常见问题</span>
            <h1 className="mt-2 text-3xl text-foreground-950 md:text-4xl">FAQ · 把话说清楚</h1>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              从“瓜可不可信”到“能不能转载”，我们把平台运行的规矩一次讲明白。找不到答案？欢迎发邮件到{" "}
              <a href={`mailto:${brand.email}`} className="text-primary-600 underline underline-offset-2">
                {brand.email}
              </a>
              。
            </p>
          </div>

          <div className="mt-10 max-w-3xl space-y-3">
            {faqList.map((f) => (
              <details key={f.q} className="group rounded-2xl border border-background-200 bg-background-50 px-6">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5">
                  <span className="text-base font-semibold text-foreground-900">{f.q}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition group-open:rotate-45 group-open:bg-primary-500 group-open:text-background-50">
                    <i className="ri-add-line"></i>
                  </span>
                </summary>
                <p className="pb-5 text-sm leading-7 text-foreground-600">{f.a}</p>
              </details>
            ))}
          </div>

          <div className="mt-10 flex flex-col items-start justify-between gap-4 rounded-3xl bg-background-100/70 p-6 sm:flex-row sm:items-center md:px-8">
            <div>
              <h2 className="text-lg font-semibold text-foreground-950">没找到你要的答案？</h2>
              <p className="mt-1 text-sm text-foreground-600">直接找编辑聊聊，投稿、纠错、转载授权都欢迎。</p>
            </div>
            <div className="flex flex-col gap-2 sm:flex-row">
              <a href={`mailto:${brand.email}`} className="inline-flex h-11 items-center justify-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-medium text-background-50 transition hover:bg-primary-400">
                <i className="ri-mail-line"></i> 发邮件
              </a>
              <Link to="/about" className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-full border border-primary-300 px-5 text-sm text-primary-700 transition hover:bg-primary-100">
                关于我们
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}